import smartSolveApi from './instances/smartsolve';

export const getReportModelByName = async (name = '', id = '') => {
  try {
    const response = await smartSolveApi.get(
      `/smartinsight/getopenreportmodel?reportKey=${name}&reportId=${id}`
    );
    return response.data;
  } catch (e) {
    throw new Error(`getReportModelByName() failed: ${e}`);
  }
};

export const getDataModel = async () => {
  try {
    const response = await smartSolveApi.get('/smartinsight/getloadcatalog');
    return response.data;
  } catch (e) {
    throw new Error(`getDataModel() failed: ${e}`);
  }
};

export const getFieldListByEntityName = async (name) => {
  try {
    const response = await smartSolveApi.get(`/smartinsight/getloaddatafields?entityName=${name}`);
    return response.data;
  } catch (e) {
    throw new Error(`getFieldListByEntityName() failed: ${e}`);
  }
};

export const saveReportModelByKey = async (saveObj) => {
  try {
    const response = await smartSolveApi.post('/smartinsight/savereportmodel', saveObj);
    return response.data;
  } catch (e) {
    throw new Error(`saveReportModelByKey() failed: ${e}`);
  }
};

export const deleteReportModelById = async (key) => {
  try {
    const response = await smartSolveApi.post('/smartinsight/deletereportmodel', key);
    return response.data;
  } catch (e) {
    throw new Error(`deleteReportModelById() failed: ${e}`);
  }
};

export const verifyReportModelExists = async (reportModelName) => {
  try {
    const response = await smartSolveApi.post('/smartinsight/verifyreportmodelexists', {
      reportModelName,
    });

    return response.data;
  } catch (e) {
    throw new Error(`verifyReportModelExists() failed: ${e}`);
  }
};

export const exportReportModelApi = async (id) => {
  try {
    const response = await smartSolveApi.post('/smartinsight/exportreportmodel', id);

    return response.data;
  } catch (e) {
    throw new Error(`exportReportModelApi() failed: ${e}`);
  }
};

export const importReportModelApi = async (file) => {
  try {
    const formData = new FormData();

    formData.append('FileName', file.name);
    formData.append('FileStream', file);

    const response = await smartSolveApi.post('/smartinsight/import', formData);

    return response;
  } catch (error) {
    throw new Error(`importReportModel() failed: ${error}`);
  }
};
